export default "__VITE_ASSET__CEMyXyGT__"